<template>
  <div class="document">
      <div class="description">
        <slot/>
      </div>
    <div class="docLinks">
      <div class="pdf">
        <slot name="pdf"></slot>
      </div>
      <div class="word">
        <slot name="word"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

.docLinks, .description {
  position: relative;
  top: 15px;
}

.docLinks {
  width: 30%;
  display: flex;
  justify-content: space-around;
}

.document {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 500px;
  border-radius: 30px;
  text-align: center;
  background: url("../img/folder.webp") no-repeat center;
  background-size: contain;
}

.description {
  width: 60%;
}

@media (min-width: 1300px) {
  .document {
    width: 33%;
  }
}

@media (max-width: 1300px) {
  .document {
    width: 45%;
    height: 250px;
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .document {
    width: 100%;
    height: 250px;
    flex-direction: column;
  }
}

</style>